const indexItems = [
  { id: 1, label: '院线电影', count: '1,286', icon: 'ri-film-line', desc: '最新上映及经典院线影片' },
  { id: 2, label: '国产剧集', count: '3,452', icon: 'ri-tv-line', desc: '热播国产电视剧全集' },
  { id: 3, label: '欧美影视', count: '2,108', icon: 'ri-global-line', desc: '美剧英剧及好莱坞电影' },
  { id: 4, label: '日韩剧场', count: '1,934', icon: 'ri-earth-line', desc: '日剧韩剧追剧首选' },
  { id: 5, label: '综艺娱乐', count: '867', icon: 'ri-mic-line', desc: '热门综艺节目全集' },
  { id: 6, label: '动漫番剧', count: '2,541', icon: 'ri-ghost-line', desc: '日漫国漫全收录' },
  { id: 7, label: '纪录片库', count: '659', icon: 'ri-compass-line', desc: 'BBC及国家地理纪录片' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium tracking-wide mb-3">
            分类
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            影视索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg mx-auto">
            按类型快速浏览全站影视资源，找到你想看的内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-5 text-center transition-all hover:border-primary-300 hover:bg-primary-50/30 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                {item.label}
              </h3>
              <p className="text-xs text-foreground-400 mb-2">{item.desc}</p>
              <span className="inline-block text-xs font-medium text-accent-500 bg-accent-50 px-2 py-0.5 rounded-full">
                {item.count} 部
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}